"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressView = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var nft_hooks_1 = require("@zoralabs/nft-hooks");

var useMediaContext_1 = require("../context/useMediaContext");

var PREFIX_ADDRESS = "0x";

var AddressView = function AddressView(_ref) {
  var address = _ref.address,
      _ref$showChars = _ref.showChars,
      showChars = _ref$showChars === void 0 ? 6 : _ref$showChars,
      className = _ref.className;

  var _a, _b;

  var _useMediaContext_1$us = useMediaContext_1.useMediaContext(),
      getStyles = _useMediaContext_1$us.getStyles,
      style = _useMediaContext_1$us.style;

  var theme = style.theme; // @ts-ignore (address can be undefined but not typed correctly for now)

  var ens = nft_hooks_1.useENSAddress(theme.useEnsResolution ? address : undefined);
  var username = nft_hooks_1.useZoraUsername(theme.useZoraUsernameResolution || ens.error ? address : undefined);
  var addressFirst = address.slice(0, showChars + PREFIX_ADDRESS.length);
  var addressLast = address.slice(address.length - showChars);

  if ((_a = ens.data) === null || _a === void 0 ? void 0 : _a.name) {
    var zoraLink = ens.data.name.endsWith(".ens") ? ens.data.name : address;
    return jsx_runtime_1.jsx("a", Object.assign({}, getStyles("addressLink", className), {
      href: "https://zora.co/".concat(zoraLink),
      target: "_blank",
      rel: "noreferrer"
    }, {
      children: jsx_runtime_1.jsx("span", {
        children: ens.data.name
      }, void 0)
    }), void 0);
  }

  if ((_b = username.username) === null || _b === void 0 ? void 0 : _b.username) {
    return jsx_runtime_1.jsx("a", Object.assign({}, getStyles("addressLink", className), {
      href: "https://zora.co/".concat(username.username.username),
      target: "_blank",
      rel: "noreferrer"
    }, {
      children: jsx_runtime_1.jsx("span", {
        children: "@".concat(username.username.username)
      }, void 0)
    }), void 0);
  } // Username loading


  if (theme.useZoraUsernameResolution && !username.error && !username.username) {
    return jsx_runtime_1.jsx("span", {
      children: "..."
    }, void 0);
  } // Ens loading


  if (theme.useEnsResolution && !ens.error && !ens.data) {
    return jsx_runtime_1.jsx("span", {
      children: "..."
    }, void 0);
  }

  return jsx_runtime_1.jsx("a", Object.assign({}, getStyles("addressLink", className), {
    href: "https://etherscan.io/address/".concat(address),
    target: "_blank",
    rel: "noreferrer"
  }, {
    children: jsx_runtime_1.jsxs("span", {
      children: [addressFirst, "...", addressLast]
    }, void 0)
  }), void 0);
};

exports.AddressView = AddressView;